const { ccclass, property } = cc._decorator;
import ViewBase from "../../../../framework/core/mvvm/view_base";
import { ListView, ListViewDir } from "../../../../framework/tools/scrollview/listview"
import Utility from "../../../../utility/utility";
import AppData from "../../../public/const/app_data";
import RecordItem from "./recordItem";

@ccclass
export default abstract class RecordView extends ViewBase {

    @property(cc.ScrollView)
    scrollview: cc.ScrollView = null;

    @property(cc.Node)
    view: cc.Node = null;

    @property(cc.Node)
    content: cc.Node = null;

    @property(cc.Node)
    prefab: cc.Node = null;

    m_list: ListView = null

    onLoad() {
        let list: ListView = new ListView({
            scrollview: this.scrollview,
            view: this.view,
            content: this.content,
            item_prefab: this.prefab,
            cb_host: this,
            item_update_func: this.update_list_item,
            select_cb: this.on_item_select,
            column: 1,
            row: 1,
            gap_y: 0,
            direction: ListViewDir.Vertical,
        });
        this.m_list = list
    }
    
    on_item_select(data: any, index: number) {
        //cc.log(data, index);
    }


    updateShow(m_Data:any = null){
        if (m_Data == null){ 
            m_Data = []
         }
        if ( m_Data.length < 7){
            for (let index = m_Data.length ; index < 7; index++) {
                const element = {goldType:null}; //设置空数据 处理
                m_Data[index] = element
            }
        }
        this.m_list.set_data(m_Data);
        this.m_list.select_item(1)
        this.m_list.scroll_to(0)
    }

    update_list_item(item: cc.Node, data: any, index: number): void {

        let _recordItem = item.getComponent(RecordItem)
        _recordItem.setData(data,index)
    }
}